import {computed,onBeforeUnmount,shallowRef,watchEffect} from 'vue'
import {useRoute} from 'vue-router'
import store from '@/store'

interface ProductContext{owner:symbol;route:string;orgId:number;id:number;name:string;code:string;kind:string}
export const consultationLists:Record<string,string>={'/main/bokes':'版型库','/main/cloths':'成衣定制','/main/retails':'成衣现货 / 预售','/main/fabrics':'面料','/main/accessories':'辅料','/main/decorations':'饰品','/main/coursecenter':'制版教学'}
export function consultationListText(path:string,orgId:number,origin:string){
  if(!consultationLists[path] || !Number.isSafeInteger(orgId) || orgId<1000)return ''
  const url=new URL(path,origin);url.searchParams.set('orgId',String(orgId))
  return `咨询商品列表：${consultationLists[path]}\n列表链接：${url.href}`
}
const current=shallowRef<ProductContext|null>(null)
export function useConsultationProduct(product:{value:any},kind:string){
  const route=useRoute(),owner=Symbol('consultation'),initialPath=route.path,orgId=Number(store.getters.orgId)
  watchEffect(()=>{
    const value=product.value
    if(route.path!==initialPath || (Number(route.query?.id)>0 && Number(value?.id)!==Number(route.query?.id)) || Number(store.getters.orgId)!==orgId || !Number.isSafeInteger(Number(value?.id)) || Number(value?.id)<=0 || !String(value?.title || value?.courseName || '').trim()){
      if(current.value?.owner===owner)current.value=null
      return
    }
    current.value={owner,route:route.fullPath,orgId,id:Number(value.id),name:String(value.title || value.courseName).trim(),code:String(value.code || '').trim(),kind}
  })
  onBeforeUnmount(()=>{if(current.value?.owner===owner)current.value=null})
}
export function useProductConsultationText(){
  const route=useRoute()
  return computed(()=>{
    const item=current.value
    if(!item || item.route!==route.fullPath || item.orgId!==Number(store.getters.orgId))return consultationListText(route.path,Number(store.getters.orgId),window.location.origin)
    const url=new URL(route.path,window.location.origin)
    url.searchParams.set('id',String(item.id));url.searchParams.set('orgId',String(item.orgId))
    return `${item.kind}：${item.name}${item.code?'\n款号：'+item.code:''}\n商品链接：${url.href}`
  })
}
